document.addEventListener("alpine:init", () => {
  Alpine.data("quickAdd", () => ({
    adding: false,
    quantity: 1,

    async addToCart(product_id, product_handle, qty = null) {
      this.adding = true;

      // Use passed quantity or fall back to component's quantity state, default to 1
      const addQuantity = qty ?? this.quantity ?? 1;

      const cart = await this.getCartData();

      const res = await fetch(`/products/${product_handle}.json`);
      const { product } = await res.json();
      const variants = product.variants;

      // Can be subscription or onetime matching items
      const matchingOneTimeItem = Array.from(cart.items).find(
        (item) => item.product_id == product_id && !item.selling_plan_allocation
      );

      if (!matchingOneTimeItem) {
        // No items in cart matched, so add item to cart
        // Find appropriate variant for the quantity being added
        const qtyVariant = variants.find((v, i) => {
          const lowerBound = parseInt(v.title.split("+")[0]);
          const upperBound = parseInt(variants[i + 1]?.title.split("+")[0]);

          if (upperBound) {
            return lowerBound <= addQuantity && addQuantity < upperBound;
          } else {
            return lowerBound <= addQuantity;
          }
        }) || variants[0];

        const itemData = { id: qtyVariant.id, quantity: addQuantity };
        await this.addCartItem(itemData);
        this.updateCartCountBubble(addQuantity);
        window.openCartDrawer()
        this.quantity = 1;
        this.adding = false;
        return;
      }

      // Item is in the cart already
      const itemToUpdate = matchingOneTimeItem;

      const newQuantity = parseInt(itemToUpdate.quantity) + addQuantity;

      // Get the new variant with quantity
      const newQtyVariant = variants.find((v, i) => {
        const lowerBound = parseInt(v.title.split("+")[0]);
        const upperBound = parseInt(variants[i + 1]?.title.split("+")[0]);

        if (upperBound) {
          return lowerBound <= newQuantity && newQuantity < upperBound;
        } else {
          return lowerBound <= newQuantity;
        }
      });

      if (newQtyVariant && itemToUpdate.variant_id != newQtyVariant.id) {
        // Upgrade variant price tier
        // Remove current variant
        await this.removeCartItem(itemToUpdate.key);
        // Add upgraded variant
        const itemData = { id: newQtyVariant.id, quantity: newQuantity };
        await this.addCartItem(itemData);
      } else {
        // Add item to current price tier
        const itemData = { [itemToUpdate.key]: newQuantity };
        await this.updateCart(itemData);
      }

      this.updateCartCountBubble(addQuantity);
      window.openCartDrawer()
      this.quantity = 1;
      this.adding = false;
    },

    async getCartData() {
      try {
        const res = await fetch("/cart.js");
        const data = await res.json();

        return data;
      } catch (err) {
        console.log(err);
      }
    },

    async addCartItem(item) {
      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(item),
        });
        const data = await res.json();
        return data;
      } catch (e) {
        console.log(e);
      }
    },

    updateCartCountBubble(qty = 1) {
      const cartCount = document.querySelectorAll(".cart-count");
      if (cartCount) {
        Array.from(cartCount).map((el) => (el.innerText = parseInt(el.innerText) + qty));
      }
    },

    async removeCartItem(id) {
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id, quantity: 0 }),
        });
        const data = await res.json();
        return data;
      } catch (e) {
        console.log(e);
      }
    },

    async updateCart(updates) {
      try {
        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        });
        const data = await res.json();
        return data;
      } catch (e) {
        console.log(e);
      }
    },
  }));
});
